import React, { useState, useMemo } from 'react';
import { Grid, Box } from '@mui/material';
import { EventColumn } from './EventColumn';
import { Event, EventStatus } from '@/types/events';
import { distributeEvents } from './utils';
import { useEventStorage } from '../../hooks/useEventStorage';

interface EventColumnsProps {
  onEdit: (event: Event) => void;
  onDelete: (id: string) => void;
  onView: (event: Event) => void;
}

export const EventColumns: React.FC<EventColumnsProps> = ({
  onEdit,
  onDelete,
  onView
}) => {
  const { events } = useEventStorage();
  const [leftStatus, setLeftStatus] = useState<EventStatus | null>(null);
  const [rightStatus, setRightStatus] = useState<EventStatus | null>(null);

  // Distribute events between columns
  const { leftEvents, rightEvents } = useMemo(() => 
    distributeEvents(events),
    [events]
  );

  // Filter events based on selected status
  const filteredLeftEvents = useMemo(() => 
    leftStatus ? leftEvents.filter(event => event.status === leftStatus) : leftEvents,
    [leftEvents, leftStatus]
  );

  const filteredRightEvents = useMemo(() => 
    rightStatus ? rightEvents.filter(event => event.status === rightStatus) : rightEvents,
    [rightEvents, rightStatus]
  );

  return (
    <Box sx={{ height: '100%', overflow: 'hidden' }}>
      <Grid container spacing={3} sx={{ height: '100%' }}>
        <Grid item xs={12} md={6} sx={{ height: '100%', minHeight: 400 }}>
          <EventColumn
            events={filteredLeftEvents}
            selectedStatus={leftStatus}
            onStatusChange={setLeftStatus}
            onEdit={onEdit}
            onDelete={onDelete}
            onView={onView}
          />
        </Grid>
        <Grid item xs={12} md={6} sx={{ height: '100%', minHeight: 400 }}>
          <EventColumn
            events={filteredRightEvents}
            selectedStatus={rightStatus}
            onStatusChange={setRightStatus}
            onEdit={onEdit}
            onDelete={onDelete}
            onView={onView}
          />
        </Grid>
      </Grid>
    </Box>
  );
};